var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.count)?_c('sup',[_c('b-badge',{attrs:{"pill":"","variant":"danger"}},[_vm._v(_vm._s(_vm.count))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }